import requests from "./request";



// 登录
export function login(data) {
    return requests({
      url: '/sys/login',
      method: 'post',
      data
    })
  }
// 验证码
  export function getCodeInfo(now) {
    return requests({
      url: '/sys/randomColorImage/1629428467008?_t='+now,
      method: 'get',
    })
  }
  // 首页信息侧数据
  export function displayInfo(data) {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/displayInfo',
      method: 'post',
      headers: {},
      data
    })
  }
  // 首页站点侧数据
  export function stationInfo(data) {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/stationInfo',
      method: 'post',
      headers: {},
      data
    })
  }
  // 粪污台账
  export function fwlist() {
    return requests({
      url: '/zh-applet-admin/appmana/survFecesLedger/list?pageNo='+1+'&pageSize='+200,
      method: 'get',
      headers: {},
    })
  }
  // 农田覆膜
  export function ntfmlist() {
    return requests({
      url: '/zh-applet-admin/appmana/survMulchRecord/list?pageNo='+1+'&pageSize='+200,
      method: 'get',
      headers: {},
    })
  }
    // 监测站实时数据
    export function getNewestData(data) {
      return requests({
        url: '/zh-applet-admin/appmana/bigScreen/getNewestData',
        method: 'post',
        headers: {},
        data
      })
    }
    // 污染物字典
  export function getPollutionDict() {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/getPollutionDict',
      method: 'get',
      headers: {},
    })
  }
  // 污染治理效果折线图
  export function getIndexSummry(data) {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/getIndexSummry',
      method: 'post',
      headers: { 'content-type': 'application/json; charset=UTF-8' },
      data: data? data : {}
    })
  }
// 土壤数据
export function getSoilSummry(data) {
  return requests({
    url: '/zh-applet-admin/appmana/bigScreen/timesIntegrate',
    method: 'post',
    headers: { 'content-type': 'application/json; charset=UTF-8' },
    data: data? data : {}
  })
}
   // 站点详情
   export function getStationDetail(stationCode) {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/getStationDetail?stationCode='+stationCode,
      method: 'post',
      headers: {},
    })
  }

    // 站点详情
   export function getStationDisplay(stationCode) {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/getStationDisplay?stationCode='+stationCode,
      method: 'get',
      headers: {},
    })
  }

     // 各个站坐标点
  export function getAllstationAndPestLight(isShowLight) {
    return requests({
      url: '/zh-applet-admin/appmana/bigScreen/getAllstationAndPestLight?isShowLight='+isShowLight,
      method: 'get',
      headers: {},
    })
  }
// 各个站坐标点
export function getCompanyList() {
  return requests({
    url: '/zh-applet-admin/appmana/bigScreen/getEntList',
    method: 'get',
    headers: {},
  })
}
  // 查询设备下各检测项的历史数据
  export function survItemSummary(obj) {
    return requests({
      url: '/appmana/bigScreen/survItemSummary',
      headers: {},
      method: 'post',
      data:obj
    })
  }

// 运维日志
// maintainTime  运维时间
// maintainNote 备注
// maintainPerson 运维人员
// maintainData1 运维内容
// maintainData2  联系方式
// maintainData3  站点位置
//?startTime=2025-11-22&endTime=2025-11-22
export function getMaintainLog(params) {
  return requests({
    url: '/appmana/bigScreen/stationMaintainPage',
    method: 'get',
    headers: {},
    params
  })
}


/**
 * //监测预警数据
 * stationCode=S_1        站点编号
 * &deployId=1679816437477228546  设备ID
 * &pageNo=1                                      页号
 * &pageSize=10                                   页宽
 * &yearStr=2026                                  年份
 *
 * 回执
 * {
 *                                 "id": "2027671112451649538",
 *                                 "tenantId": "租户",
 *                                 "deployCode": "16111113",
 *                                 "deployId": "1679816437477228546",
 *                                 "alertTime": "告警时间",
 *                                                "itemCode":"检测项编号"
 *                                 "itemName": "钾离子",
 *                                 "deviceName": "设备名称",
 *                                                 "fullDeviceName":"带站点名称的设备名字"
 *                                                 "readStatus":"low=偏低，high=偏高",
 *                                                 "survUnit":"单位"
 *                                                "survValue":"监测值"
 *                                                "nomalValue":"正常值范围"
 *                         }
 * @param params
 * @returns {*}
 */
export function doGetAlertRecord(params) {
  return requests({
    url: '/appmana/bigScreen/alertRecord',
    method: 'get',
    headers: {},
    params
  })
}
